import bg from '@assets/images/dot-pattern-bg.png'
import { useEffect } from 'react'
import { useNavigate, useOutletContext } from 'react-router'
import { Container } from '@/components/ui/container'
import { XCircleIcon } from '@/components/ui/icons'
import { Spinner } from '@/components/ui/spinner'
import { useGetPhotoset } from '@/features/photoset/queries/use-get-photoset'
import type { PhotosetURLParams } from '@/features/photoset/types'
import { routes } from '@/routes'
import { useTranslation } from '@/translations/i18n'

export const PhotosetRejected = () => {
	const { t } = useTranslation()
	const { urlParams } = useOutletContext<{ urlParams: PhotosetURLParams }>()
	const navigate = useNavigate()
	const photosetQuery = useGetPhotoset(
		{
			id: urlParams.id
		},
		{ enabled: false }
	)

	useEffect(() => {
		if (
			photosetQuery?.data &&
			photosetQuery.data.reason_decline_id === null
		) {
			navigate(routes.WELCOME.path, { replace: true })
		}
	}, [photosetQuery.data, navigate])

	return (
		<Container className='relative flex flex-col items-center justify-center'>
			<div
				className='fixed inset-0 z-(--z-background) bg-neutral-50'
				style={{ backgroundImage: `url(${bg})` }}
			/>
			{photosetQuery.isFetching ? (
				<Spinner className='fill-neutral-500' size={48} />
			) : (
				<div className='flex flex-col items-center justify-center gap-8'>
					<XCircleIcon className='fill-danger-600' size={40} />
					<div className='flex w-[392px] flex-col items-center gap-2 text-center'>
						<h1 className='font-bold text-display-xs text-neutral-900'>
							{t('photoset:rejected.title')}
						</h1>
						<p className='text-neutral-900 text-xl'>
							{t('photoset:rejected.paragraph')}
						</p>
					</div>
				</div>
			)}
		</Container>
	)
}

PhotosetRejected.displayName = 'PhotosetRejected'
